import { Box, Typography, IconButton, Grid, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { adminPermissionsType, listMenuType } from "../../types";
import './../../assets/css/sidebar.css';
import Logo from './../../assets/images/logo.png';

const listMenu: listMenuType[] = [
    {
        label: 'Main',
        icon: '',
        to: null,
        permission: ''
    },
    {
        label: 'Dashboard',
        icon: 'menu-icon tf-icons bx bx-home-circle',
        to: '/',
        permission: ''
    },
    {
        label: 'Transactions',
        icon: '',
        to: null,
        permission: ''
    },
    {
        label: 'PAYIN',
        icon: 'menu-icon tf-icons bx bx-list-plus',
        to: '/payin-transactions',
        permission: ''
    },
    {
        label: 'PAYOUT',
        icon: 'menu-icon tf-icons bx bx-list-minus',
        to: '/payout-transactions',
        permission: ''
    },
    {
        label: 'SETTLEMENT',
        icon: 'menu-icon tf-icons bx bx-list-minus',
        to: '/settlement-transactions',
        permission: ''
    },
    {
        label: 'Requests',
        icon: '',
        to: null,
        permission: ''
    },
    {
        label: 'PAYIN',
        icon: 'menu-icon tf-icons bx bx-list-plus',
        to: '/payin-request',
        permission: ''
    },
    {
        label: 'PAYOUT',
        icon: 'menu-icon tf-icons bx bx-list-minus',
        to: '/payout-request',
        permission: ''
    },
    {
        label: 'SETTLEMENT',
        icon: 'menu-icon tf-icons bx bx-list-minus',
        to: '/settlement-request',
        permission: ''
    },
    {
        label: 'Reports',
        icon: '',
        to: null,
        permission: ''
    },
    {
        label: 'DEPOSIT',
        icon: 'menu-icon tf-icons bx bx-list-plus',
        to: '/deposit-report',
        permission: ''
    },
    {
        label: 'WITHDRAW',
        icon: 'menu-icon tf-icons bx bx-list-minus',
        to: '/withdraw-report',
        permission: ''
    },
    {
        label: 'Others',
        icon: '',
        to: null,
        permission: ''
    },
    {
        label: 'Sub account',
        icon: 'menu-icon tf-icons bx bxs-user-account',
        to: '/sub-account',
        permission: ''
    },
    {
        label: 'Change password',
        icon: 'menu-icon tf-icons bx bxs-lock-alt',
        to: '/change-password',
        permission: ''
    },
    {
        label: 'Logout',
        icon: 'menu-icon tf-icons bx bx-arrow-back',
        to: '/logout',
        permission: ''
    },
]

interface PropsType {
    isOpen: boolean,
    handleToggleOpen: (state: boolean) => void,
    permissions: adminPermissionsType
}

const Sidebar = ({ isOpen, handleToggleOpen, permissions }: PropsType) => {
    let location = useLocation();
    const [pathName, setPathName] = useState<string | null>(null);

    useEffect(() => {
        setPathName(location.pathname);
    }, [location]);
    return (
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="app-brand demo">
                <Link to="/" className="app-brand-link" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    {/* <img src={Logo} width="100%" /> */}
                    <Typography fontSize={28} fontWeight={`bold`} align="center">
                        BULLPAY
                    </Typography>
                </Link>
                {/* <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto">
                    <i className="bx menu-toggle-icon d-none d-xl-block fs-4 align-middle" />
                    <i className="bx bx-x d-block d-xl-none bx-sm align-middle" />
                </a> */}
            </div>
            <ul className="menu-inner py-1">
                {
                    permissions !== null && listMenu.map((item: listMenuType, index: number) => {
                        return (
                            !item.permission || item.permission && permissions[item.permission as keyof adminPermissionsType] ? <li className={`menu-item ${pathName === item.to && "active"}`} key={index}>
                                {
                                    item.to ? <Link to={item.to} className="menu-link">
                                        <i className={`${item.icon}`} />
                                        <div>{item.label}</div>
                                    </Link> : <div style={{ fontSize: 12, marginTop: 2 }}>
                                        {item.label}
                                    </div>
                                }
                                
                            </li> : null
                        )
                    })
                }
                {/* <li className="menu-item">
                    <a href="#" className="menu-link" onClick={() => handleToggleOpen(isOpen ? false : true)}>
                        <i className={`menu-icon tf-icons bx bx-${isOpen ? 'x' : 'fullscreen'}`} />
                        <div>ซ่อน</div>
                    </a>
                </li> */}
            </ul>
        </aside>
    )
}

export default Sidebar;